import cntl from "cntl";
import PropTypes from "prop-types";
import { NavMenuItemCard } from "../molecules";
import { CARD_MENU_ITEM_CARD_VARIANTS } from "../constants";

const propTypes = {
  cards: PropTypes.array,
};

function NavMenuOnlyImages({ cards }) {
  const sectionsWrapperCn = () => cntl`
    md:p-8
    flex
    flex-col
    items-center
    justify-center
  `;

  const sectionsCn = () => cntl`
    grid
    gap-2
    w-full
    grid-cols-1
    md:grid-cols-2
    xl:grid-cols-3
  `;

  return (
    <div className={sectionsWrapperCn()}>
      <div className={sectionsCn()}>
        {cards.map((card, index) => {
          return (
            <NavMenuItemCard
              text={card?.text}
              media={card?.media}
              title={card?.title}
              key={`nav-menu-item-card-${index}`}
              variant={CARD_MENU_ITEM_CARD_VARIANTS.image_card}
            />
          );
        })}
      </div>
    </div>
  );
}

NavMenuOnlyImages.propTypes = propTypes;
export default NavMenuOnlyImages;
